import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

export function createInternalPermissionGuard(
  permissionChecker: (authService: AuthenticationService) => boolean
): CanActivateFn {
  return () => {
    const authService = inject(AuthenticationService);
    const router = inject(Router);
    return authService.getIsAuthedInternalUserWhenReady().pipe(
      map(isAuthedInternalUser =>
        isAuthedInternalUser && permissionChecker(authService)
          ? true
          : router.createUrlTree(['/permissions-error'])
      )
    );
  };
}

export function createIdentityGuard(
  authObservableFn: (authService: AuthenticationService) => Observable<boolean>
): CanActivateFn {
  return () => {
    const authService = inject(AuthenticationService);
    const router = inject(Router);
    return authObservableFn(authService).pipe(
      map(isAuthed => (isAuthed ? true : router.createUrlTree([])))
    );
  };
}
